module.exports = __webpack_public_path__ + "img/spice1.10275eed.webp";